import * as ST from "./styled";
import PhoneIcon from "@mui/icons-material/Phone";
import { Typography } from "@mui/material";

export const Phones = () => (
    <ST.Link href="tel:+78005559995">
		  <PhoneIcon sx={{ color: "primary.main" }}/>
      <Typography variant="h6">
        8-800-555-999-5
			</Typography>
    </ST.Link>
);